<template>
    <div class="wrapper default">
        <div class="container-fluid">
            <div class="main-content col-12 col-md-12 col-lg-12">
                <div class="top-logo-hh">
                    <router-link to="/" class="logo">
                        <!--<img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />-->
                    </router-link>
                </div>
            </div>
            <div class="row">
                <!--<div class="col-12 col-md-6 col-lg-6 order-md-12">
                    <div class="account-box">

                        <div class="account-box-title">
                            آیا عضو فروشگاه دیجی سرور نیستید؟
                            <p class="p-f-f">
                                از لینک زیر برای عضویت اقدام کنید.
                            </p>
                        </div>
                        <div>

                        </div>
                        <div class="account-box-content">
                            <div class="row">
                                <div class="col-12 col-md-12 col-lg-12">
                                    <div class="account-benefits">
                                        <h3 class="faq-title icon-plus">
                                            مزایای عضویت در دیجی سرور
                                        </h3>
                                        <ul class="faq-text">
                                            <li>ایجاد پنل کاربری برای مشاهده سفارشات و محصولات</li>
                                            <li>ذخیره سازی اطلاعات سفارشات شما</li>
                                            <li>سرعت بخشی به فرایند خرید</li>
                                            <li>اطلاع از قیمت فروش محصولات</li>
                                            <li>خرید بی دغدغه و آسان و امکان عودت کالا</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-lg-12">
                                    <div class="form-account-row form-account-submit">
                                        <div class="parent-btn">
                                            <router-link to="/register" class="dk-btn dk-btn-info">
                                                ثبت نام
                                                <i class="now-ui-icons users_circle-08"></i>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>-->
                <div class="main-content col-12 col-md-12 col-lg-12 order-md-1">
                    <div class="account-box">
                        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                            <img style="position:absolute;top:50%;left:42%;z-index:100" src="/assets/img/loader/loader.svg" />
                        </div>

                        <div class="account-box-title text-center" style="font-size: 22px; color: #213258">آموزشگاه رانندگی معجزه بندرعباس</div>
                        <div class="account-box-content">
                            <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                <li v-for="error in errors.all()">{{ error }}</li>
                            </ul>
                            <form @submit.prevent="validateForm" class="form-account">
                                <div class="row">
                                    <div class="col-12 col-md-12 col-lg-12">
                                        <div class="form-account-title">نام کاربری</div>
                                        <div class="form-account-row">
                                            <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                                            <input name="username" class="input-field" type="text" v-model="user.UserName" v-validate="{ required: true }" data-vv-as="نام کاربری"
                                                   placeholder="نام کاربری خود را وارد نمایید">
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12 col-lg-12">
                                        <div class="form-account-title">
                                            کلمه عبور

                                            <!--<router-link to="/forgetPassword" tag="a" class="btn-link-border form-account-link">
                                                رمز
                                                عبور خود را فراموش
                                                کرده ام
                                            </router-link>-->
                                        </div>

                                        <div class="form-account-row">
                                            <label class="input-label">
                                                <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                            </label>
                                            <input name="password" class="input-field" type="password" v-model="user.Password" v-validate="{required: true , min:1 , max: 25}" data-vv-as="کلمه عبور"
                                                   placeholder="کلمه عبور خود را وارد نمایید">
                                        </div>
                                    </div>
                                    <div class="flex w-100 margin-t-25">
                                        <div class="form-account-row form-account-submit">
                                            <div class="parent-btn">
                                                <button type="submit" class="dk-btn dk-btn-info">
                                                    ورود به سیستم
                                                    <i class="fa fa-sign-in"></i>
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>




                            </form>
                        </div>
                        <div class="account-box-footer">
                            <!--<span>کاربر جدید هستید؟</span>

                            <router-link to="/register" tag="a" class="btn-link-border">
                                ثبت‌نام کنید
                            </router-link>-->

                        </div>
                    </div>
                </div>



            </div>
        </div>

    </div>

</template>

<script> 
    import { httpPromise } from "../../../module/httpUtility.js";
    import { initialSite } from "../../../module/initialSite"
    export default {
        data() {
            return { user: {}, isShowSppiner: false }
        }, 
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identities/Accounts/Login', 'post', JSON.stringify(this.user),
                            response => {
                                if (response.data.Value.UserGroupId != 1) {
                                    localStorage.setItem('accessToken', response.data.Value.Token);
                                    this.$store.commit('setUserFullName', response.data.Value.UserFullName);
                                    var path = IsNullOrEmptyString(this.$route.query.returnUrl) ? '/eduDrvSessions' : this.$route.query.returnUrl;
                                    this.isShowSppiner = false;
                                    window.location.href = path;
                                } else {
                                    toastr.error('شما مجوز دسترسی به این بخش را ندارید');
                                }

                            },
                            response => {
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
            resetForm() {
                this.user = {};
                this.$validator.reset();
                this.$validator.errors.clear();
            }
        },
        beforeMount: function () {
            createPageTitle('ورود به سیستم');
            initialSite(this);
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        beforeRouteEnter: (to, from, next) => {
            next(vm => {
                if (isUserLogined())
                    vm.$router.push('/eduDrvSessions');
            });
        }
    }
</script>

<style scoped>
    .top-logo-hh {
        background: #fff;
        width: auto;
        margin: 70px auto;
    }

        .top-logo-hh .logo img {
            height: 38px;
        }

        .top-logo-hh .logo {
            width: 156px;
            height: 60px;
            position: absolute;
            left: 50%;
            bottom: -20%;
            transform: translate(-50%);
            text-align: center;
            line-height: 60px;
        }

    .margin-t-25 {
        margin-top: 25px;
    }

    .account-box-title .p-f-f {
        color: #909090;
        font-size: 25px;
    }

    .account-box {
        min-width: 700px;
    }

    .btn-redirect-page {
        background-color: #fff8f8;
        border-bottom: 1px dashed #1ca2bd;
        margin-top: 10px;
        display: inline-block;
        border-radius: 5px;
        color: #1ca2bd;
        transition: all .3s;
        padding: 6px;
        font-size: 12px;
    }

        .btn-redirect-page:hover {
            transition: all .3s;
            color: #1ca2bd;
        }

    .account-benefits ul li::before {
        content: '\f00c';
        font-family: FontAwesome;
        margin: 0 -10px 0 5px;
        width: 1.2em;
        color: #333;
        font-size: 150%;
        vertical-align: middle;
    }

    .account-benefits ul li {
        color: #747474;
    }

    .icon-plus::before {
        font-family: FontAwesome;
        content: "\f067";
    }

    .faq-title {
        margin-bottom: 5px;
        margin-top: 30px;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
    }

    @media only screen and (min-width: 0px) and (max-width: 740px) {
        .account-box {
            min-width: auto;
        }

        @media only screen and (min-width: 0px) and (max-width: 640px) {
        }

        .account-box {
            margin: 35px auto;
        }
    }
</style>